const module = { name: 'shared/utils/urlHelpers', exports: {} }; const exports = module.exports;



import { fd_url_manager as links } from 'require-core';

function generateTspLink(location, queryParams = {}) {
    return links.tsp({ location_movietimes: `${location}_movietimes` }, queryParams);
}
module.exports = {
    generateTspLink,
};
export default module.exports;